"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _lab = require("@material-ui/lab");
var _styles = require("@material-ui/core/styles");
var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));
var _axios = _interopRequireDefault(require("axios"));
var _moment = _interopRequireDefault(require("moment"));
var _activityFilter = _interopRequireDefault(require("../activity-filter"));
var _teaserSlider = _interopRequireDefault(require("../teaser-slider"));
var _uidrawer = _interopRequireDefault(require("../uidrawer"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "relative"
  },
  header: {
    alignItems: "center",
    gap: theme.spacing(2),
    justifyContent: "space-between"
  },
  headline: {
    color: theme.palette.elementHeadline,
    fontWeight: 600,
    "& span": {
      display: "inline-block",
      fontWeight: 700,
      paddingBottom: theme.spacing(0.5),
      position: "relative",
      "&::before": {
        background: theme.palette.primary.main,
        bottom: 0,
        content: "''",
        height: 1,
        left: 0,
        position: "absolute",
        right: 0
      }
    }
  },
  filterButton: {
    alignItems: "center",
    background: "none",
    border: "none",
    color: theme.palette.primary.main,
    cursor: "pointer",
    display: "flex",
    marginLeft: "auto",
    paddingRight: 0,
    "& span": {
      fontWeight: 700
    }
  },
  filterIcon: {
    background: theme.palette.primary.main,
    borderRadius: "50%",
    color: theme.palette.common.white,
    height: 40,
    marginLeft: theme.spacing(1),
    width: 40
  },
  filterWrapper: {
    paddingBottom: "calc(env(safe-area-inset-bottom) + 90px)",
    paddingTop: theme.spacing(2.5)
  },
  filterButtonGroup: {
    bottom: 0,
    left: 0,
    position: "fixed"
  }
}));
const formatData = data => {
  const {
    items
  } = data;
  if (!items) {
    return [];
  }
  return items.map(item => {
    const {
      date: {
        from: dateFrom,
        timeFrom,
        timeTo,
        to: dateTo
      } = {},
      id,
      media = [],
      pageName,
      title
    } = item;
    return {
      dateFrom,
      dateTo,
      id,
      link: "".concat(pageName).concat(dateFrom ? "#".concat(dateFrom) : ""),
      media,
      timeFrom,
      timeTo,
      title
    };
  });
};
const generateDummyData = counter => {
  let items = [];
  for (let i = 0; i < counter; i++) {
    items.push({
      id: i,
      link: ""
    });
  }
  return items;
};
const Headline = _ref => {
  let {
    from,
    to
  } = _ref;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.headline,
    variant: "body1"
  }, !(0, _moment.default)(from).diff(to, "minutes") && /*#__PURE__*/_react.default.createElement("span", null, (0, _moment.default)(from).format("dddd"), ","), " ", (0, _moment.default)(from).format("D. MMMM YYYY"), !!(0, _moment.default)(from).diff(to, "minutes") && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " - "), !(0, _moment.default)(from).diff(to, "minutes") && /*#__PURE__*/_react.default.createElement("span", null, (0, _moment.default)(to).format("dddd"), ","), (0, _moment.default)(to).format("D. MMMM YYYY")));
};
const ActivityList = _ref2 => {
  var _filter$query$title, _filter$query;
  let {
    categories,
    providers
  } = _ref2;
  const [filter, setFilter] = (0, _react.useState)({
    from: (0, _moment.default)(),
    to: (0, _moment.default)().add(3, "days"),
    groups: categories !== null && categories !== void 0 ? categories : [],
    query: ""
  });
  const [filterOpen, setFilterOpen] = (0, _react.useState)(false);
  const {
    REACT_APP_PATH,
    REACT_APP_PROVIDER_ID
  } = process.env;
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListActivity.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&lang=").concat(i18n.language, "&MediaLimit=1&DateFrom=").concat((0, _moment.default)(filter === null || filter === void 0 ? void 0 : filter.from).format("DD.MM.YYYY"), "&DateTo=").concat((0, _moment.default)(filter === null || filter === void 0 ? void 0 : filter.to).format("DD.MM.YYYY"), "&Groups=").concat(filter === null || filter === void 0 ? void 0 : filter.groups, "&Keyword=").concat((_filter$query$title = filter === null || filter === void 0 || (_filter$query = filter.query) === null || _filter$query === void 0 ? void 0 : _filter$query.title) !== null && _filter$query$title !== void 0 ? _filter$query$title : "");
  const {
    isLoading,
    data,
    status
  } = (0, _reactQuery.useQuery)(["list-activity", filter, i18n.language, providers], () => _axios.default.get(url));
  let items = generateDummyData(4);
  if (status === "success") {
    items = formatData(data === null || data === void 0 ? void 0 : data.data);
  }
  const handleClick = () => {
    setFilterOpen(!filterOpen);
  };
  const handleFilter = data => {
    setFilter({
      ...filter,
      ...data
    });
  };
  const handleSearch = data => {
    setFilter({
      ...filter,
      ...data
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.root,
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.header,
    container: true
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    animation: "wave",
    height: 28,
    width: 200,
    variant: "text"
  }) : /*#__PURE__*/_react.default.createElement(Headline, {
    from: filter === null || filter === void 0 ? void 0 : filter.from,
    to: filter === null || filter === void 0 ? void 0 : filter.to
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: css.filterButton,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body1",
    component: "span"
  }, t("site.ui.buttons.filter")), /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    className: css.filterIcon,
    src: "/img/icons/filter.svg",
    size: 24
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 1.5
  }, items.length > 0 ? /*#__PURE__*/_react.default.createElement(_teaserSlider.default, {
    data: items,
    lang: i18n.language,
    mediaFormat: "activity-teaser-slider",
    showBookmark: true
  }) : /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    severity: "error"
  }, t("site.ui.errors.noActivities"))), /*#__PURE__*/_react.default.createElement(_uidrawer.default, {
    bottom: false,
    open: filterOpen,
    setMenuOpen: setFilterOpen,
    title: t("site.ui.pagetitles.filter")
  }, /*#__PURE__*/_react.default.createElement(_core.Container, {
    className: css.filterWrapper
  }, /*#__PURE__*/_react.default.createElement(_activityFilter.default, {
    data: filter,
    onFilter: handleFilter,
    onSearch: handleSearch,
    onFilterOpen: handleClick
  }))));
};
var _default = exports.default = ActivityList;